import { CellProps } from './Cell';

export const actionsColumnIdentifier = 'actionItem';

export type Column<T> = {
  header: string;
  accessor: keyof T;
  element?: React.ComponentType<CellProps>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCellProps?: (row: T) => Record<string, any>;
  sortDisabled?: boolean;
};

export type UserData = {
  actionItem: React.ReactElement | null;
  b2bSchoolId: string;
  educationStatus: string;
  email: string;
  firstName: string;
  lastName?: string;
  id: string;
  subscriptionStatus: string;
  subscriptionUpdatedAt: string | undefined;
  voucherId: string;
  voucherShortCode: string;
  memberOfClasses?: { id: string; name: string }[];
  teacherOfClasses?: { id: string; name: string }[];
  schoolRoles?: { role: string }[];
  isTeacher: boolean;
};

export type VoucherData = {
  actionItem: React.ReactElement | null;
  id: string;
  shortCode: string;
  usageCount: number;
  validUntil: string | undefined;
  allowedUsage: number;
};

export type ClassData = {
  actionItem: React.ReactElement | null;
  id: string;
  name: string;
  studentsCount: string;
  teachersCount: string | React.ReactElement;
  matchType?: {
    students: { id: string; name: string }[];
    className: string;
  };
};

export type ParticipantData = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type WorksheetStudentData =
  // TODO: Table extend of types? & ParticipantData
  {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    worksheetCount: number;
    assignedWorksheetCount: number;
    memberOfClasses: { id: string; name: string }[];
    actionItem: React.ReactElement | null;
  };
export type ClassWorksheetsData = {
  id: string;
  title: string;
  sharedBy: string;
  results: string;
  actionItem: React.ReactElement | null;
};

export type WorksheetTemplateData = {
  id: string;
  title: string;
  description: string;
  createdBy: string;
  createdAt: string;
  actionItem: React.ReactElement | null;
};
